export default __webpack_public_path__ + "static/media/buzzfeed2.77c82b2c.svg";